import type { PurchaseOrder } from "@shared/types";

function resolveFulfillmentDate(order: PurchaseOrder): string {
  return order.expectedFulfillmentDate ?? order.createdAt;
}

/**
 * Orders newest-fulfillment-first, falling back to createdAt when
 * expectedFulfillmentDate is missing and as a tiebreaker when both orders
 * resolve to the same fulfillment date.
 */
export function compareByFulfillmentThenCreatedDesc(a: PurchaseOrder, b: PurchaseOrder): number {
  const fulfillmentA = resolveFulfillmentDate(a);
  const fulfillmentB = resolveFulfillmentDate(b);
  const fulfillmentDiff = new Date(fulfillmentB).getTime() - new Date(fulfillmentA).getTime();
  if (fulfillmentDiff !== 0) return fulfillmentDiff;

  return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
}
